import { ref, computed, Ref, ComputedRef } from 'vue'
import fuzzysort from 'fuzzysort'

interface UseSearchableConfig<T, U> {
  defaultSearchTerm?: string
  prepareItem: (item: T) => U
  fuzzySortOptions: {
    keys: string[]
    threshold?: number
  }
}

export function useSearchable<T, U>(
  items: Ref<T[]>,
  config: UseSearchableConfig<T, U>
): {
  searchValue: Ref<string>
  results: ComputedRef<U[]>
} {
  const searchValue = ref(config.defaultSearchTerm || '')
  const preparedItems = computed(() => items.value.map(config.prepareItem))

  const results = computed(() => {
    return fuzzysort
      .go(searchValue.value, preparedItems.value, {
        keys: config.fuzzySortOptions.keys,
        threshold: config.fuzzySortOptions.threshold || 0,
        all: true,
      })
      .map((result) => result.obj)
  })

  return {
    searchValue,
    results,
  }
}
